<template lang="pug">
v-container(fluid)
  faq-page(v-if="sessaoValida")
</template>

<script>
import { mapMutations } from "vuex";
import FaqPage from "./faq/faq-page.vue";
import verificarSessao from "./verificarSessao";

export default {
  name: "Faq",
  components: { FaqPage },
  mixins: [verificarSessao],
  data: () => ({ sessaoValida: false }),
  methods: {
    ...mapMutations("app", ["setTitle", "isControl"]),
  },
  mounted() {
    if (!this.iniciarVerificacaoSessao()) return;
    this.isControl(true);
    this.setTitle("FAQ");
    this.sessaoValida = true;
  },
};
</script>
